export default function RogersHowItWorksSection() {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-[#F7F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">How It Works</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">5 Steps to Your Passport</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          {[
            { num: "01", title: "Start Online", desc: "Choose your processing speed and complete our secure online application." },
            { num: "02", title: "Document Prep", desc: "We review your documents and schedule your facility visit near Rogers." },
            { num: "03", title: "Courier Handoff", desc: "Our registered courier picks up and delivers your sealed envelope directly." },
            { num: "04", title: "Passport Delivered", desc: "Your passport arrives at your Rogers address via secure overnight shipping." },
            { num: "05", title: "Travel Ready", desc: "Your passport in hand — ready for business trips, cruises, or family vacations." },
          ].map((s, i) => (
            <div key={i} className="text-center">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1A365D] text-white font-bold text-lg mx-auto mb-4">{s.num}</div>
              <h3 className="font-bold text-[#1A365D] text-base mb-2">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}